export default __webpack_public_path__ + "6db27563838bbfb8830092c6e80cf57a.png";